import { get } from 'app/shared/utils/fetchr';

// Utils
import routes from 'app/shared/utils/routes';

export const retrieveRelevantOrgs = () => {
  return get(routes.patronus.orgsRelevantOrgsDetails);
};
